import React, { Component } from 'react';
import PopoverSwiper from './PopoverSwiper';
import PopoverModal from './PopoverModal';
import { colors } from './../../styles/theme.json';


export default class extends Component {
  constructor(props) {
    super(props);
    this.keydown = this._handleKeyDown.bind(this);
  }
  
  _handleKeyDown(event) {
    switch ( event.keyCode ) {
      case 27:
        this.props.ClickFunction();
        break;
      default: 
        break;
    };
  };

  componentWillMount(){
    document.addEventListener('keydown', this.keydown);
  };

  componentWillUnmount() {
    document.removeEventListener('keydown', this.keydown);
  };

  render() {
    return (
      <PopoverModal>
        <div id={'popover-wrapper'}>
          <button id={'close-popover'} onClick={this.props.ClickFunction} />
          <PopoverSwiper PortfolioImages={this.props.Images} currentImage={this.props.CurrentImage}/>
          <style jsx>{`
            :global(#slideshow-modal) {
              width: 100%;
              height: 100vh;
              position: fixed;
              top: 0;
              left: 0;
              z-index: 10000;
              background: ${colors.black};
            }
            #popover-wrapper {
              width: 100%;
              height: 100%;
              position: absolute;
              top: 0;
              left: 0;
            }
            #close-popover {
              position: fixed;
              top: 2.5rem;
              right: 2.5rem;
              height: 2rem;
              width: 3.5rem;
              border: 0;
              background-color: rgba(0,0,0,0);
              z-index: 12000;
              cursor: pointer;
            }
            #close-popover:after {
              position: absolute;
              top: 0;
              right: 0;
              z-index: 12001;
              content: 'CLOSE';
              color: white;
              font-weight: bold;
            }
          `}</style>
        </div>
      </PopoverModal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/popover/Popover.js